const AboutPage = () => {
    return (
        <p>This is about page of Floating Cottages.</p>
    )
}

export default AboutPage;